module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Date From:")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": "YYYY-MM-DD",
      "lang": "en"
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Date From:")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": "YYYY-MM-DD",
      "lang": "en"
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Customer Region:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.objQuoteFilters.regions,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "multiple": "",
      "outline": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckRegions()
      }
    },
    model: {
      value: (_vm.objCustomerRegion),
      callback: function($$v) {
        _vm.objCustomerRegion = $$v
      },
      expression: "objCustomerRegion"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-bottom": "0px",
      "padding-top": "0px"
    },
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Originator:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.objQuoteFilters.originators,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "multiple": "",
      "outline": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckOriginators()
      }
    },
    model: {
      value: (_vm.objOriginator),
      callback: function($$v) {
        _vm.objOriginator = $$v
      },
      expression: "objOriginator"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-bottom": "0px",
      "padding-top": "0px"
    },
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Status:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.objQuoteFilters.status,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "multiple": "",
      "outline": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckStatus()
      }
    },
    model: {
      value: (_vm.objStatus),
      callback: function($$v) {
        _vm.objStatus = $$v
      },
      expression: "objStatus"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-bottom": "0px",
      "padding-top": "0px"
    },
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Customer Company:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.objQuoteFilters.companies,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "multiple": "",
      "outline": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckCompany()
      }
    },
    model: {
      value: (_vm.objCustomerCompany),
      callback: function($$v) {
        _vm.objCustomerCompany = $$v
      },
      expression: "objCustomerCompany"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-bottom": "0px",
      "padding-top": "0px"
    },
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Customer User:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.objQuoteFilters.users,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "multiple": "",
      "outline": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckUser()
      }
    },
    model: {
      value: (_vm.objCustomerUser),
      callback: function($$v) {
        _vm.objCustomerUser = $$v
      },
      expression: "objCustomerUser"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-bottom": "0px",
      "padding-top": "0px"
    },
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Project:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.objQuoteFilters.projects,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "multiple": "",
      "outline": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckProject()
      }
    },
    model: {
      value: (_vm.objProject),
      callback: function($$v) {
        _vm.objProject = $$v
      },
      expression: "objProject"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-bottom": "0px",
      "padding-top": "0px"
    },
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Specifier:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.objQuoteFilters.specifiers,
      "item-text": "name",
      "item-value": "id",
      "autocomplete": "",
      "multiple": "",
      "outline": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckSpecifier()
      }
    },
    model: {
      value: (_vm.objSpecifier),
      callback: function($$v) {
        _vm.objSpecifier = $$v
      },
      expression: "objSpecifier"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncGenerateReport('true')
      }
    }
  }, [_vm._v("Generate")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncClearFilters()
      }
    }
  }, [_vm._v("Clear Filters")])], 1)])], 1)], 1)
},staticRenderFns: []}